import styled from 'styled-components';

const MyCarsContentWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
`;

const LoanDetailWrapper = styled.div`
  align-content: center;
  background-color: ${(props) => props.theme.color.neutral.v200};
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Brandon Text';
  margin: 0 auto;
  padding: 10px 24px 46px;
  max-width: 1800px;
  padding-bottom: 64px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 10px 32px 64px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding-bottom: 64px;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

const TransactionHistoryBankInfoWrapper = styled.div`
  display: grid;
  grid-column-gap: 15px;
  max-width: 1060px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    grid-template-columns: 1fr;
  }
`;

export {
  MyCarsContentWrapper,
  LoanDetailWrapper,
  SpinnerWrapper,
  TransactionHistoryBankInfoWrapper,
};
